window.showPageMessage = function(message, duration = 4000) {
  const el = document.getElementById('pageMessage');
  if (!el) return;

  const text = el.querySelector('.pageMessage__Text');
  const timer = el.querySelector('.pageMessage__Timer');

  text.textContent = message;

  el.classList.add('pageMessage--Active', 'pageMessage--Countdown');

  // reset animation
  timer.style.animationDuration = duration + 'ms';
  timer.style.animationName = 'none';
  timer.offsetHeight; // force reflow
  timer.style.animationName = '';

  clearTimeout(el._hideTimeout);

  el._hideTimeout = setTimeout(() => {
    el.classList.remove('pageMessage--Active', 'pageMessage--Countdown');
  }, duration);
};